<template>
  <div class="pag-news-list">
    <ul v-if="newsList.length">
      <li v-for="item in newsList" :key="item.id">
        <router-link :to="{name:'PageNewsDetail',query:{id:item.id}}">
          <div class="list-box">
            <div class="list-image">
              <img :src="item.newsPictureUrl" alt="">
            </div>
            <div class="list-main">
              <div class="list-title el2">
                {{item.newsTitle}}
              </div>
              <div class="list-describe el2">
                {{item.newsSummary}}
              </div>
              <div class="list-time">时间：{{item.createTime | formtDay}}</div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
    <!-- footer -->
    <base-footer />
  </div>
</template>
<script>
import BaseFooter from '@/components/BaseFooter'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import dayjs from 'dayjs'
export default {
  name: 'PageNewsList',

  components: {
    BaseFooter
  },

  data () {
    return {
      newsList: []
    }
  },

  created () {
    this.getNewsList()
  },

  filters: {
    formtDay (val) {
      return dayjs(val).format('YYYY-MM-DD')
    }
  },

  methods: {
    async getNewsList () {
      showLoading()
      const { errCode, errMsg, data } = await api.getNewsList()
      hideLoading()
      if (errCode === 0) {
        this.newsList = data.rows
      } else {
        showAlert(errMsg)
      }
    }
  }

}
</script>
<style lang="less" scoped>
.pag-news-list{
  background-color: #ffffff;
  ul{
    padding-bottom: 100px;
    li{
      a{
        display: block;
      }
    }
  }
  .list-box{
    padding: 40px 50px;
    border-bottom: 1PX solid @main-gray5;
    display: flex;
    .list-image{
      width: 270px;
      height: 176px;
      border-radius: 4PX;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .list-main{
      padding-left: 30px;
      color: @main-gray4;
      flex: 1;
      line-height: 1.6;
      .list-title{
        font-size: 30px;
        color: @main-gray2;
      }
      .list-describe{
        font-size: 24px;
        margin: 10px 0;
      }
      .list-time{
        font-size: 24px;
      }
    }
  }
}

</style>
